/**
 * KitData
 * Utilities that are replacements for (or are similar to) lodash/underscore methods
 *
 * OR are
 * - basic data assertion, coercion, evaluation, or manipulation methods
 */

import { BasicDataType } from '../types';

// not-empty assertion for basic datatypes
export const hasValue = (val?: BasicDataType | BasicDataType[]): boolean =>
  val !== undefined && val !== null && val !== '';

/**
 * Coerce value to boolean
 * @param val
 * @returns
 */
export const toBoolean = (val: unknown): boolean => {
  if (typeof val === 'string') {
    return val === 'true' ? true : false;
  }
  if (typeof val === 'number') {
    return val === 0 ? false : true;
  }
  // return booleans or truthiness
  return val ? true : false;
};

/**
 * Native replacement for lodash isEmpty method
 * @see https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
 * @param obj
 * @returns
 */
export const isEmpty = (obj) =>
  [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;

/**
 * Native replacement for lodash _.get method to safely get a nested property
 * @see https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
 *
 * @param obj
 * @param path
 * @param defaultValue
 */
export function getProp(
  obj: Record<string, unknown>,
  path: string,
  defaultValue: unknown = undefined
): unknown {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
}
